module.exports = __webpack_public_path__ + "static/media/executive-summary.4e17516c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/executive-summary.jpg
// module id = 2938
// module chunks = 0